import React from "react";
import cbcLogo from "../../Assets/cbc_logo.svg";
import './css/home.css';

const Bottom = () => {
  return(
    <div className="bottom">
      <img src={cbcLogo} alt=""/>
    </div>
  )
}

export default Bottom;